const PopperModifiers = {
  modifiers: {
    computeStyle: {
      gpuAcceleration: false,
    },
  },
};

export default PopperModifiers;
